import { render, staticRenderFns } from "./group-slot.mpx?vue&type=template&id=541bbf89&isComponent&outputPath=components%2Fgroup-slot5372fa5e%2Findex"
import script from "./group-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fgroup-slot5372fa5e%2Findex"
export * from "./group-slot.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Fgroup-slot5372fa5e%2Findex"
import style0 from "./group-slot.mpx?vue&type=style&index=0&id=541bbf89&prod&lang=stylus&mpxStyleOptions=%7B%22mid%22%3A%22_5372fa5e%22%7D&isComponent&outputPath=components%2Fgroup-slot5372fa5e%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports